<!--Save Poygan-->
<div class="modal fade rtl " id="savePolygan" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="">ثبت محدوده</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ">
                <div class="col-11 mx-auto">
                    <label class="">نام محدوده</label>
                    <input [formControl]="nameControl" class="form-control">
                </div>



            </div>

            <div class="modal-footer">

                <button *ngIf="!editMode" type="button" class="btn btn-success" (click)="saved.emit()">ثبت <i
                        class="fa fa-angle-double-down"></i> </button>

                <button *ngIf="editMode" type="button" class="btn btn-primary" (click)="edited.emit()"> ویرایش <i
                        class="fa fa-angle-double-down"></i> </button>

                <button type="button" class="btn btn-danger " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>

            </div>

        </div>

    </div>

</div>
